export default "__VITE_ASSET__CUearw6o__"